<template>
  <div>
    <img src=""/>
    <v-row justify="space-around">
      <v-col cols="11">
        <v-card
            class="mx-auto "
            outlined
        >
          <v-row class="d-flex mx-7 justify-end">
            <v-btn
                v-if="(data.applicationStatus in ['0','-2','4',0,-2,4] && data.editable==='1')"
                class="ma-3  col-1" color="primary"
                :to="{ name: 'EditApplication',params:{id:this.$route.params.id}}">
              {{ $t("EDIT") }}
            </v-btn>
            <v-btn class="ma-3 col-1 "
                   v-if="data.applicationIdus >0 "
                   @click="printApplication">
              {{ $t('PRINT') }}
            </v-btn>
           <!-- <v-btn v-if="data.deleteable ==1 "
                   class="ma-3  col-1"
                   color="error"
                   @click="deleteApplication">
              {{ $t('DELETE') }}
            </v-btn>-->
            <v-btn class="ma-3 col-1"
                   @click="returnBack">
              {{ $t('BACK') }}
            </v-btn>
          </v-row>
          <v-row class="justify-center">

            <v-col cols="11" lg="3">
              <p class="d-inline-block">
                <span class="   light-blue--text">{{ $t("ADMISSION_DATA.APPLICATION_ID") + " : " }} </span>
                <span>{{ data.applicationId }}</span>
              </p>
            </v-col>
            <v-col cols="11" lg="3">
              <p class="d-inline-block">
                <span class="   light-blue--text">{{ $t("ADMISSION_DATA.APPLICATION_DATE") + " : " }} </span>
                <span>{{ data.applicationDate }}</span>
              </p>
            </v-col>
            <v-col cols="11" lg="3">
              <p class="d-inline-block">
                <span class="   light-blue--text">{{ $t("ADMISSION_DATA.APP_STATUS") + " : " }} </span>
                <span>{{ status }}</span>
              </p>
            </v-col>
            <v-col cols="11" lg="3">
              <p class="d-inline-block">
                <span class="   light-blue--text">{{ $t("UserData.DESIRE_NUMBER") + " : " }} </span>
                <span>{{ data.desireNumber }}</span>
              </p>
            </v-col>
          </v-row>
          <v-expansion-panels
              v-model="opend"
              multiple
          >

            <v-expansion-panel>
              <v-expansion-panel-header color="primary" class="white--text">
                {{ $t("ADMISSION_DATA.STEP1.PERSONAL_DATA") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="my-4">
                  <v-col cols="12" lg="6">
                    <p>
                      <span class="   light-blue--text">{{ $t('ADMISSION_DATA.STEP1.AR_FULLNAME') }} :</span>
                      <span>{{ data.arName }}</span>
                    </p>
                    <p>
                      <span class="  light-blue--text">{{ $t('ADMISSION_DATA.STEP1.EN_FULLNAME') }} :</span>
                      <span>{{ data.enName }}</span>
                    </p>

                   <p v-if="data.personalImageURL">
                      <v-chip
                          class="ma-2 py-0"
                          color="primary"
                          text-color="white"
                          @click="dialog=!dialog;showingFile=data.personalImageURL;"
                      >
                        <v-avatar left>
                          <v-icon>mdi-eye</v-icon>
                        </v-avatar>
                        {{ $t('ADMISSION_DATA.STEP1.IMAGE') }}
                      </v-chip>
                    </p>

                    <p class="col-lg-3 col-12 px-0 py-0 d-inline-block">
                      <span class="  light-blue--text">{{ $t("ADMISSION_DATA.STEP1.TYPE") + " : " }}  </span>
                      <span>{{ data.gender ? serverTranslate(data.gender.name) : "" }}</span> &nbsp;
                    </p>

                    <p class="col-lg-3 col-12 px-0 py-0 d-inline-block">
                      <span class="  light-blue--text">{{ $t("ADMISSION_DATA.STEP1.RELIGION") + " : " }}  </span>
                      <span>{{ data.religion ? serverTranslate(data.religion.name) : "" }}</span> &nbsp;
                    </p>


                    <p class="col-lg-7 col-12 px-0 py-0 d-inline-block">
                      <span class="  light-blue--text">{{ $t('ADMISSION_DATA.STEP1.ID') }} :</span>
                      <span>{{ data.cardID }}</span>
                    </p>
                    <p>
                               <span class="  light-blue--text">{{ $t("ADMISSION_DATA.STEP1.BIRTHDATE") + " : " }}
                               </span>
                      <span>
                               {{ data.birthdate }}
                               </span>
                    </p>


                    <p>
                               <span class="light-blue--text">{{ $t("ADMISSION_DATA.STEP1.BIRTHPLACE") + " : " }}
                               </span>
                      <span>
                                   {{ data.addressCountry ? serverTranslate(data.birthPlaceCountry.name) : "" }}
                                   {{ data.addressState ? "/" + serverTranslate(data.birthPlaceState.name) : "" }}
                                   {{ data.addressCity ? "/" + serverTranslate(data.birthPlaceCity.name) : "" }}
                               </span>
                    </p>

                    <p>
                           <span class="  light-blue--text">
                               {{ $t("UserData.NATIONALITY") }}:
                           </span>
                      <span>
                           {{ data.nationality ? serverTranslate(data.nationality.name) : "" }}
                           </span>
                    </p>
                    <p v-if="data.guardianCardUrl">
                      <v-chip
                          class="ma-2 py-0"
                          color="primary"
                          text-color="white"
                          @click="dialog=!dialog;showingFile=data.guardianCardUrl;"
                      >
                        <v-avatar left>
                          <v-icon>mdi-eye</v-icon>
                        </v-avatar>
                        {{ $t('ADMISSION_DATA.STEP1.GUARDIAN_CARD') }}
                      </v-chip>
                    </p>
                  </v-col>
                  <hr dark light class="d-lg-none .d-xl-flex"/>
                  <v-col cols="12" lg="6">
                    <p class="d-lg-none d-xl-flex light-blue--text">{{ $t("ADMISSION_DATA.STEP1.CONTACTS") }}</p>
                    <p>
                      <span class="light-blue--text">{{
                          $t('ADMISSION_DATA.STEP1.TELEPHONE')
                        }} / {{ $t('ADMISSION_DATA.STEP1.PHONE') }} : </span>
                      <bdi>{{ data.mobile }} {{ data.telephone && data.mobile ? "/" : "" }}{{ data.telephone }}</bdi>
                    </p>
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP1.EMAIL') }} : </span>
                      <span> {{ data.email }} </span>
                    </p>

                    <p class="mb-0">
                               <span class="light-blue--text">{{ $t("ADMISSION_DATA.STEP1.ADDRESS") + " : " }}
                               </span>
                      <span>
                                   {{ data.addressCountry ? serverTranslate(data.addressCountry.name) : "" }}
                                   {{ data.addressState ? "/" + serverTranslate(data.addressState.name) : "" }}
                                   {{ data.addressCity ? "/" + serverTranslate(data.addressCity.name) : "" }}
                               </span>
                    </p>
                    <p v-if="data.cardImageUrl">
                      <v-chip
                          class="ma-2 py-0"
                          color="primary"
                          text-color="white"
                          @click="dialog=!dialog;showingFile=data.cardImageUrl;"
                      >
                        <v-avatar left>
                          <v-icon>mdi-eye</v-icon>
                        </v-avatar>
                        {{ $t('ADMISSION_DATA.STEP1.ID_IMAGE') }}
                      </v-chip>
                    </p>
                    <p v-if="data.birthCertUrl">
                      <v-chip
                          class="ma-2 py-0"
                          color="primary"
                          text-color="white"
                          @click="dialog=!dialog;showingFile=data.birthCertUrl;"
                      >
                        <v-avatar left>
                          <v-icon>mdi-eye</v-icon>
                        </v-avatar>
                        {{ $t('ADMISSION_DATA.STEP1.BIRTH_CERT') }}
                      </v-chip>
                    </p>
                    <p v-if="data.militaryFormUrl">
                      <v-chip
                          class="ma-2 py-0"
                          color="primary"
                          text-color="white"
                          @click="dialog=!dialog;showingFile=data.militaryFormUrl;"
                      >
                        <v-avatar left>
                          <v-icon>mdi-eye</v-icon>
                        </v-avatar>
                        {{ $t('ADMISSION_DATA.STEP1.MILITARY_FORM') }}
                      </v-chip>
                    </p>
                  </v-col>

                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header color="primary" class="white--text">{{
                  $t("ADMISSION_DATA.STEP2.NAME")
                }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="my-4">
                  <v-col class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP2.CERTIFICATION') }} : </span>
                      <span>
                                      {{ data.certificateTypes ? serverTranslate(data.certificateTypes.name) : "" }}
                                  </span>
                    </p>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP2.MAJOR') }} : </span>
                      <span>
                                      {{ data.divisionType ? serverTranslate(data.divisionType.name) : "" }}
                                  </span>
                    </p>
                  </v-col>
                  <v-col v-if="data.equationCertificateTypes && data.equationCertificateTypes.name"
                         class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP2.EQUIVALENT_CERT_TYPE') }} : </span>
                      <span>
                                      {{
                          data.equationCertificateTypes ? serverTranslate(data.equationCertificateTypes.name) : ""
                        }}
                                  </span>
                    </p>
                  </v-col>
                  <v-col v-if="data.equationCertificateName.name || data.otherCertificateText"
                         class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP2.CERTIFICATE_NAME') }} : </span>
                      <span>{{ serverTranslate(data.equationCertificateName.name) || data.otherCertificateText }}</span>
                    </p>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP2.YEAR') }} : </span>
                      <span>{{ data.preQualYear ? data.preQualYear.name.replace("|", "-") : "" }}</span>
                    </p>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6" v-if="data.preQualCountry || data.preQualCountry.name">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP2.CERT_FROM_COUNTRY') }} : </span>
                      <span>{{ serverTranslate(data.preQualCountry.name) }}</span>
                    </p>
                  </v-col>

                  <v-col class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP2.SUM') }} : </span>
                      <span>{{ data.preQualTotal }}</span>
                    </p>
                  </v-col>

                   <v-col class="py-0" cols="12" lg="6" v-if="data.percentage">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP2.PERCENTAGE') }} : </span>
                      <span>{{ data.percentage }}</span>
                    </p>
                  </v-col>


                  <v-col class="py-0" cols="12" lg="6" v-if="data.PreQualificationFileUrl">

                    <v-chip
                        @click="(data.PreQualificationFileExtension==='pdf'?openPdfDialog(data.PreQualificationFileUrl):(dialog=!dialog,showingFile=data.PreQualificationFileUrl))"
                        class="ma-2"
                        color="primary"
                        text-color="white"

                    >
                      <v-avatar left>
                        <v-icon>mdi-eye</v-icon>
                      </v-avatar>
                      {{ $t('ADMISSION_DATA.STEP2.CERTIFICATE_FILE') }}
                    </v-chip>
                  </v-col>


                <v-col class="py-0" cols="12" lg="6" v-if="data.stuConsentFileUrl">
                    <v-chip
                        @click="(data.stuConsentFileExtension==='pdf'?openPdfDialog(data.stuConsentFileUrl):(dialog=!dialog,showingFile=data.stuConsentFileUrl))"
                        class="ma-2"
                        color="primary"
                        text-color="white"
                    >
                      <v-avatar left>
                        <v-icon>mdi-eye</v-icon>
                      </v-avatar>
                      {{ $t('ADMISSION_DATA.STEP2.CONSENT_FILE') }}
                    </v-chip>
                  </v-col>

                  <v-col class="py-0" cols="12" lg="6" v-if="data.QualificationImageUrl">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        text-color="white"
                        @click="dialog=!dialog;showingFile=data.QualificationImageUrl;"
                    >
                      <v-avatar left>
                        <v-icon>mdi-eye</v-icon>
                      </v-avatar>
                      {{ $t('ADMISSION_DATA.STEP2.CERTIFICATE_IMAGE') }}
                    </v-chip>
                  </v-col>

                  <v-col class="py-0" cols="12" lg="6" v-if="data.QualificationImageUrl2">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        text-color="white"
                        @click="dialog=!dialog;showingFile=data.QualificationImageUrl2;"
                    >
                      <v-avatar left>
                        <v-icon>mdi-eye</v-icon>
                      </v-avatar>
                      {{ $t('ADMISSION_DATA.STEP2.CERTIFICATE_IMAGE2') }}
                    </v-chip>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6" v-if="data.QualificationImageUrl3">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        text-color="white"
                        @click="dialog=!dialog;showingFile=data.QualificationImageUrl3;"
                    >
                      <v-avatar left>
                        <v-icon>mdi-eye</v-icon>
                      </v-avatar>
                      {{ $t('ADMISSION_DATA.STEP2.CERTIFICATE_IMAGE3') }}
                    </v-chip>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6" v-if="data.residenceFile">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        text-color="white"
                        @click="dialog=!dialog;showingFile=data.residenceFile;"
                    >
                      <v-avatar left>
                        <v-icon>mdi-eye</v-icon>
                      </v-avatar>
                      {{ $t('ADMISSION_DATA.STEP2.STU_RESIDENCE_IMAGE') }}
                    </v-chip>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6" v-if="data.guardianResidenceFile">
                    <v-chip
                        class="ma-2"
                        color="primary"
                        text-color="white"
                        @click="dialog=!dialog;showingFile=data.guardianResidenceFile;"
                    >
                      <v-avatar left>
                        <v-icon>mdi-eye</v-icon>
                      </v-avatar>
                      {{ $t('ADMISSION_DATA.STEP2.LEGAL_GUARDIAN_RESIDENCE_IMAGE') }}
                    </v-chip>
                  </v-col>


                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header color="primary" class="white--text">{{
                  $t("ADMISSION_DATA.STEP3.NAME")
                }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="my-2">
                  <v-col cols="12" class="py-0" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP3.ACDYEAR') }} : </span>
                      <span>{{ data.appYear ? serverTranslate(data.appYear.name) : "" }}</span>
                    </p>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP3.SEMESTER') }} : </span>
                      <span>{{ data.appSemeter ? serverTranslate(data.appSemeter.name) : "" }}</span>
                    </p>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP3.FACULTY') }} : </span>
                      <span>{{ serverTranslate(data.applicationFaculty.name) }}</span>
                    </p>
                  </v-col>
                  <v-col class="py-0" cols="12" lg="6">
                    <p>
                      <span class="light-blue--text">{{ $t('ADMISSION_DATA.STEP3.BRANCH') }} : </span>
                      <span>{{ data.branch ? serverTranslate(data.branch.name) : "" }}</span>
                    </p>
                  </v-col>

                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="data.payment && (data.payment.status == 1 ||data.payment.status == 0 )">
              <v-expansion-panel-header color="primary" class="white--text">
                {{ $t("ADMISSION_DATA.STEP4.TABLETITLE") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>

                <v-row v-if="data.paymentReceiptFile || data.offlineReceiptNum">
                  <v-col cols="6">
                    <v-chip v-if="data.paymentReceiptFile"
                            class="ma-2"
                            color="primary"
                            text-color="white"
                            @click="dialog=!dialog;showingFile=data.paymentReceiptFile;"
                    >
                      <v-avatar left>
                        <v-icon>mdi-eye</v-icon>
                      </v-avatar>
                      {{ $t('ADMISSION_DATA.STEP2.RECEIPT_IMAGE') }}
                    </v-chip>
                  </v-col>
                  <v-col cols="6">
                    <p v-if="data.offlineReceiptNum">
                      <span class="light-blue--text">{{$t('ADMISSION_DATA.STEP4.RECEIPTNUM')}} : </span>
                      <span v-if="data.offlineReceiptNum ">{{ data.offlineReceiptNum }}</span>
                    </p>
                  </v-col>
                </v-row>


                <v-row  v-else class="my-2">
                  <v-col>
                    <p class="text-center"
                       v-if="data.payment && !data.paymentReceiptFile && (!data.payment.referenceNumber || data.payment.status === 2)">
                      <v-chip
                          class="px-8"
                      >
                        {{ $t("NO_DATA") }}
                      </v-chip>

                    </p>

                    <v-simple-table width="100%"
                                    v-else-if="data.payment && (data.payment.referenceNumber )"
                                    elevation="10"
                                    class="rounded-0">
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th class="text-center"
                              :class="{'d-none':!isPaid}">
                            <strong>{{ $t("ADMISSION_DATA.STEP4.PAIDDATE") }}</strong>
                          </th>
                          <th class="text-center"><strong> {{ $t("ADMISSION_DATA.STEP4.REFERENCENUM") }}</strong></th>
                          <th class="text-center"
                              :class="{'d-none':isPaid}">
                            <strong> {{ $t("ADMISSION_DATA.STEP4.EXPIRYPERIOD") }}</strong>
                          </th>
                          <th class="text-center"><strong> {{ $t("ADMISSION_DATA.STEP4.PAID") }}</strong></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td class="text-center"
                              :class="{'d-none':!isPaid}">
                            {{ data.payment && data.payment.paymentDate ? data.payment.paymentDate : "" }}
                          </td>
                          <td class="text-center">
                            {{ data.payment && data.payment.referenceNumber ? data.payment.referenceNumber : "" }}
                          </td>
                          <td class="text-center"
                              :class="{'d-none':isPaid}">{{ $t("ADMISSION_DATA.STEP4.PERIOD") }}
                          </td>
                          <td class="text-center">
                            <v-icon v-if="data.payment && data.payment.status === 1"
                                    color="success">mdi-check-outline
                            </v-icon>
                            <v-icon v-else color="error">mdi-close-outline</v-icon>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-card>

      </v-col>

    </v-row>
    <ad-confirmDialog ref="confirm"></ad-confirmDialog>


    <ad-show-files
        v-if="dialog"
        :on="dialog"
        :src="showingFile"
        @close="colseModal()"
    ></ad-show-files>
  </div>
</template>
<script>
import serverTranslationsMixin from "@/mixins/serverTranslations";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import ImagePreview from "./ImagePreview";


export default {
  name: "ad-ViewApplication",
  components: {
    "ad-confirmDialog": ConfirmDialog,
    "ad-show-files": ImagePreview
  },
  mixins: [serverTranslationsMixin],
  data() {
    return {
      opend: [0, 1, 2, 3],
      locale: localStorage.lang,
      showingFile: "",
      dialog: false,
      data: {
        offlineReceiptNum:'',
        applicationId: "",
        nationality: "",
        gender: "",
        religion: "",
        telephone: "",
        birthdate: "",
        studentName: "",
        email: "",
        addressCountry: "",
        addressState: "",
        addressCity: "",
        preQualCountry: "",
        preQualYear: "",
        certificateTypes: "",
        equationCertificateTypes: "",
        equationCertificateName: "",
        otherCertificateText: "",
        preQualTotal: "",
        applicationFaculty: "",
        applicationDate: "",
        applicationStatus: 0,
        arName: "",
        enName: "",
        applicationIdus: "",
        desireNumber: ""
      }
    }
  },
  methods: {
    openPdfDialog(fileUrl) {
      const base64toBlob = data => {
        // Cut the prefix `data:application/pdf;base64` from the raw base 64
        const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
          out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], {type: 'application/pdf'});
      };

      const blob = base64toBlob(fileUrl);
      const url = URL.createObjectURL(blob)
      window.open(url, '_blank')
    },
    colseModal() {
      this.dialog = false;
    },
    returnBack() {
      this.$router.push({name: "ListApplications"})
    },
    printApplication() {
      this.$router.push({
        name: "PrintApplication",
        params: {
          id: this.$route.params.id
        }
      });


    },
    deleteApplication() {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "DELETE_CONFIRMATION")
          .then(confirm => {
            if (confirm) {
              const data = {
                applicationID: this.$route.params.id
              };
              this.$http
                  .delete("/api/applications/delete_application/", {
                    data: data,
                  })
                  .then(
                      res => {
                        this.$toasted.show(this.serverTranslate(res.data.message), {
                          type: "success",
                          icon: "check_circle_outline",
                          theme: "bubble",
                          position: "bottom-left",
                          duration: 3000
                        });
                        this.returnBack();
                      },
                      err => {
                        this.$toasted.show(
                            this.serverTranslate(err.response.data.message),
                            {
                              type: "error",
                              icon: "error_outline",
                              theme: "bubble",
                              position: "bottom-left",
                              duration: 3000
                            }
                        );
                      }
                  );
            }
          });
      event.stopPropagation();
    }
  },
  computed: {
    isPaid() {
      return this.data.payment && this.data.payment.status == 1;
    },
    status() {
      return this.data.applicationIdus == 7 ? this.$t("SEND_NO_FEES") :
          this.data.applicationIdus ?(['5','6',5,6].includes(this.data.applicationIdus)?this.$t('UNDER_REVIEW'):this.$t("ADMISSION_DATA.APP_STATUSES")[this.data.applicationIdus] ):''
    }
  },
  created() {
    this.data.applicationId = this.$route.params.id;
    this.$http
        .post("/api/applications/details_application/", {"applicationId": this.data.applicationId})
        .then(
            res => {
              // get deletable flag from here
              Object.assign(this.data, res.data.data.application_details);
            },
            err => {
              this.$toasted.show(
                  this.serverTranslate(err.response.data.message),
                  {
                    type: "error",
                    icon: "error_outline",
                    theme: "bubble",
                    position: "bottom-left",
                    duration: 5000
                  }
              );
              this.returnBack();
            }
        );
  }
}
</script>
